import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { consumeEmergentSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        await consumeEmergentSession(sessionId);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0a0a0c] text-[#e6c687]">
      <div className="pfi-overline">Completing sign-in…</div>
    </div>
  );
}
